import { RouterOutlet } from '@angular/router';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FooterComponent } from '../main/footer/footer.component';
import { SupportHeaderComponent } from './support-header/support-header.component';

@Component({
	selector: 'app-support-layout',
	templateUrl: './support-layout.component.html',
	styleUrl: './support-layout.component.css',
	imports: [SupportHeaderComponent, RouterOutlet, FooterComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportLayoutComponent { }
